import "./prioritySelector.scss";
import Button from "../button/button";
export default function PrioritySelector({priority, onSelect}) {

  return (
    <div className="prioritySelector">
      <label>اولویت:</label>
      <Button text="بالا" onClick={() => onSelect(1)} active={priority === 1} className="highPriority" />
      <Button text="معمولی" onClick={() => onSelect(2)} active={priority === 2} className="mediumPriority" />
      <Button text="کم" onClick={() => onSelect(3)} active={priority === 3} className="lowPriority" />
    </div>
  );
}
